/**
 * created by Fabio Fusco
 */

import {Component, OnInit, Input,Output, Injector, forwardRef, EventEmitter,AfterContentInit} from '@angular/core';
import {NG_VALUE_ACCESSOR, NgControl, ControlValueAccessor} from '@angular/forms';
import { AlertaService} from '../../services/alerta.service';
import * as _ from "underscore";

const VARS_ASSOC_VALUE_ACCESSOR: any = {
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => VarsAssocComponent)
};

@Component({
    selector: 'app-vars-assoc',
    templateUrl: './vars-assoc.component.html',
    styleUrls: ['./vars-assoc.component.scss'],
    providers:[VARS_ASSOC_VALUE_ACCESSOR]
})
export class VarsAssocComponent implements OnInit,AfterContentInit,ControlValueAccessor {

    control: NgControl;
    var_name:any;
    empty:any;
    element_obj: Object;

    @Input() id:any;
    @Input() label:string;
    @Input() submitted:boolean=false;
    @Output() check= new EventEmitter();

    constructor(private  inj: Injector,
                private alerta:AlertaService
               ) {}

    ngAfterContentInit(){
        if(typeof this.element_obj == 'string'){
            this.element_obj={};
        }
        if(!this.element_obj){
           this.element_obj={};
           }
        this.isEmpty();
        }

    ngOnInit() {
        this.control = this.inj.get(NgControl);
        }

    setVar(key){
        if(!this.element_obj){
            this.element_obj={};
        }
        if(!key){
            return;
        }
        this.check.emit(false);
        if(!_.isEmpty(this.element_obj)){
            for(let k of Object.keys(this.element_obj)){
                if(k==key){
                    this.alerta.addAlert('warning','Name Var already Exists!!');
                    return false;
                          }
                    }
                }
        this.element_obj[key]='';
        this.var_name='';
        this.isEmpty();
        this.propagateChange(this.element_obj);
        }

    removeValue(key){
        delete this.element_obj[key];
        if(this.isEmpty()){
            this.element_obj=null;
            this.propagateChange(this.element_obj);
        };
        this.checkForm();
    }

    isEmpty(){
        this.empty=_.isEmpty(this.element_obj);
        return this.empty;
    }

    checkForm(){
        if(this.isEmpty()){
            return this.check.emit(false)
        }
        _.chain(this.element_obj)
            .values().find((v)=>{
                if(v==''||v==null){
                    return this.check.emit(false)
                }else{
                    this.propagateChange(this.element_obj);
                    return  this.check.emit(true)}}).value()
    }

    //---------CONTROL ACCES FUNCTIONS---------

    propagateChange = (_: any) => {};
    onTouched = (_: any) => {};

    get value(): any {
        console.log(this.element_obj)
        return this.element_obj; };

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    writeValue(value: any): void {
        this.element_obj = value;
    }

}




// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/components/vars-assoc/vars-assoc.component.ts